import UserList from '../components/user/UserList'; // @ts-ignore
import Login from '../components/auth/Login'; // @ts-ignore
import CreateUser from '../components/user/CreateUser'; // @ts-ignore
import EditUser from '../components/user/EditUser'; // @ts-ignore
import JobList from '../components/Job/JobList'; // @ts-ignore
import EditJob from '../components/Job/EditJob'; // @ts-ignore
import CreateJob from '../components/Job/CreateJob'; // @ts-ignore
import Dashboard from '../components/Dashboard'; // @ts-ignore
import Orderer from '../components/controlls/Orderer.vue'; // @ts-ignore
import Delivery from '../components/controlls/Delivery.vue'; // @ts-ignore
import Endcontroll from '../components/controlls/Endcontroll.vue'; // @ts-ignore
import TabletScanAuftrag from '../components/tablet/TabletScanAuftrag.vue'; // @ts-ignore
import Monitoring from '../components/monitor/Monitoring.vue'; // @ts-ignore
import Monitor from '../components/monitor/Monitor.vue'; // @ts-ignore
import nothing from '../components/error/Nothing.vue'; // @ts-ignore
import error from '../components/error/404.vue'; // @ts-ignore
import OutsourceList from '../components/outsource/OutsourceList.vue'; // @ts-ignore
import OutsourceEntrance from '../components/outsource/OutsourceEntrance.vue'; // @ts-ignore
import OutsourceOutput from '../components/outsource/OutsourceOutput.vue'; // @ts-ignore
import SupplierList from '../components/supplier/SupplierList.vue'; // @ts-ignore
import WorkStepList from '../components/workstep/WorkStepList'; // @ts-ignore
import MaterialList from '../components/material/MaterialList'; // @ts-ignore
import ThicknsessList from '../components/thickness/ThicknessList'; // @ts-ignore
import FormatList from '../components/format/FormatList'; // @ts-ignore
import JobMaterialList from '../components/material/JobMaterialList'; // @ts-ignore
import JobDeliveryList from '../components/material/JobDeliveryList'; // @ts-ignore
import JobOverviewList from '../components/Job/JobOverviewList'; // @ts-ignore
import store from '../store/Store';
const routes = [
    {
        path: '/userlist',
        component: UserList,
        beforeEnter: (to, from, next) => {
            // reject the navigation
            if (store.getters.userHasRole('Superadmin')) {
                next();
            }
            else {
                return next('/404');
            }
        },
    },
    {
        path: '/login',
        component: Login
    },
    {
        path: '/user/create',
        component: CreateUser,
        beforeEnter: (to, from, next) => {
            // reject the navigation
            if (store.getters.userHasRole('Superadmin') || store.getters.userHasRole('Admin')) {
                next();
            }
            else {
                return next('/404');
            }
        },
    },
    {
        path: '/users/:id/edit',
        component: EditUser,
        beforeEnter: (to, from, next) => {
            // reject the navigation
            if (store.getters.userHasRole('Superadmin') || store.getters.userHasRole('Admin')) {
                next();
            }
            else {
                return next('/404');
            }
        },
    },
    {
        path: '/job',
        component: JobList,
        beforeEnter: (to, from, next) => {
            // reject the navigation
            if (store.getters.userHasRole('Superadmin') || store.getters.userHasRole('Admin')) {
                next();
            }
            else {
                return next('/404');
            }
        },
    },
    {
        path: '/job/:id/edit',
        component: EditJob,
        beforeEnter: (to, from, next) => {
            // reject the navigation
            if (store.getters.userHasRole('Superadmin') || store.getters.userHasRole('Admin')) {
                next();
            }
            else {
                return next('/404');
            }
        },
    },
    {
        path: '/job/create',
        component: CreateJob,
        beforeEnter: (to, from, next) => {
            // reject the navigation
            if (store.getters.userHasRole('Superadmin') || store.getters.userHasRole('Admin')) {
                next();
            }
            else {
                return next('/404');
            }
        },
    },
    {
        path: '/dashboard',
        component: Dashboard,
        beforeEnter: (to, from, next) => {
            // reject the navigation
            if (store.getters.userHasRole('Superadmin') || store.getters.userHasRole('Admin')) {
                next();
            }
            else {
                return next('/404');
            }
        },
    },
    {
        path: '/order',
        component: Orderer,
        beforeEnter: (to, from, next) => {
            // reject the navigation
            if (store.getters.userHasRole('Superadmin') || store.getters.userHasRole('Admin')) {
                next();
            }
            else {
                return next('/404');
            }
        },
    },
    {
        path: '/receive',
        component: Delivery,
        beforeEnter: (to, from, next) => {
            // reject the navigation
            if (store.getters.userHasRole('Superadmin') || store.getters.userHasRole('Admin')) {
                next();
            }
            else {
                return next('/404');
            }
        },
    },
    {
        path: '/controll',
        component: Endcontroll,
        beforeEnter: (to, from, next) => {
            // reject the navigation
            if (store.getters.userHasRole('Superadmin') || store.getters.userHasRole('Admin')) {
                next();
            }
            else {
                return next('/404');
            }
        },
    },
    {
        path: '/Monitoring',
        name: "Monitoring",
        component: Monitoring,
    },
    {
        path: '/monitor',
        name: "Monitor",
        component: Monitor,
    },
    {
        path: '/',
        component: nothing,
    }, {
        path: '/404',
        component: error,
    },
    {
        path: '/outsourcelist',
        component: OutsourceList,
        beforeEnter: (to, from, next) => {
            // reject the navigation
            if (store.getters.userHasRole('Superadmin') || store.getters.userHasRole('Admin')) {
                next();
            }
            else {
                return next('/404');
            }
        },
    },
    {
        path: '/outsourceentrance',
        component: OutsourceEntrance,
        beforeEnter: (to, from, next) => {
            // reject the navigation
            if (store.getters.userHasRole('Superadmin') || store.getters.userHasRole('Admin')) {
                next();
            }
            else {
                return next('/404');
            }
        },
    },
    {
        path: '/outsourceoutput',
        component: OutsourceOutput,
        beforeEnter: (to, from, next) => {
            // reject the navigation
            if (store.getters.userHasRole('Superadmin') || store.getters.userHasRole('Admin')) {
                next();
            }
            else {
                return next('/404');
            }
        },
    },
    {
        path: '/suppliers',
        component: SupplierList,
        beforeEnter: (to, from, next) => {
            // reject the navigation
            if (store.getters.userHasRole('Superadmin') || store.getters.userHasRole('Admin')) {
                next();
            }
            else {
                return next('/404');
            }
        },
    },
    {
        path: '/workstep',
        component: WorkStepList,
        beforeEnter: (to, from, next) => {
            // reject the navigation
            if (store.getters.userHasRole('Superadmin') || store.getters.userHasRole('Admin')) {
                next();
            }
            else {
                return next('/404');
            }
        },
    },
    {
        path: '/material',
        component: MaterialList,
        beforeEnter: (to, from, next) => {
            // reject the navigation
            if (store.getters.userHasRole('Superadmin') || store.getters.userHasRole('Admin')) {
                next();
            }
            else {
                return next('/404');
            }
        },
    },
    {
        path: '/thickness',
        component: ThicknsessList,
        beforeEnter: (to, from, next) => {
            // reject the navigation
            if (store.getters.userHasRole('Superadmin') || store.getters.userHasRole('Admin')) {
                next();
            }
            else {
                return next('/404');
            }
        },
    },
    {
        path: '/format',
        component: FormatList,
        beforeEnter: (to, from, next) => {
            // reject the navigation
            if (store.getters.userHasRole('Superadmin') || store.getters.userHasRole('Admin')) {
                next();
            }
            else {
                return next('/404');
            }
        },
    },
    {
        path: '/jobmaterial',
        component: JobMaterialList,
        beforeEnter: (to, from, next) => {
            // reject the navigation
            if (store.getters.userHasRole('Superadmin') || store.getters.userHasRole('Admin')) {
                next();
            }
            else {
                return next('/404');
            }
        },
    },
    {
        path: '/jobdelivery',
        component: JobDeliveryList,
        beforeEnter: (to, from, next) => {
            // reject the navigation
            if (store.getters.userHasRole('Superadmin') || store.getters.userHasRole('Admin')) {
                next();
            }
            else {
                return next('/404');
            }
        },
    },
    {
        path: '/job/worklogs/',
        component: TabletScanAuftrag,
    },
    {
        path: '/job/:id/overview/',
        component: JobOverviewList,
        beforeEnter: (to, from, next) => {
            // reject the navigation
            if (store.getters.userHasRole('Superadmin') || store.getters.userHasRole('Admin')) {
                next();
            }
            else {
                return next('/404');
            }
        },
    },
];
export default routes;
